document.getElementById("fabrictitle").innerHTML = "Fabric: " + document.querySelector(".rio-product-option-title").children[0].innerHTML;
document.getElementById("rio-options").onclick = function(){document.getElementById("fabrictitle").innerHTML = "Fabric: " + document.querySelector(".rio-product-option-title").children[0].innerHTML;};

var rioproductoptiontitle = document.querySelector(".rio-product-option-title");

if (rioproductoptiontitle.innerText.indexOf("Fabric") != -1) {rioproductoptiontitle.style.visibility="hidden";};
if (rioproductoptiontitle.innerHTML.includes('Sling')){rioproductoptiontitle.style.visibility="visible";};



var sgroup = localStorage.getItem('lcgroup');
  if(sgroup == "OP"){
    document.getElementById("OUTDOOR-PERFORMANCE").checked = true;;
  } else if(sgroup == "ST"){
    document.getElementById("SOFT-TOUCH").checked = true;
  } else if(sgroup == "WR"){
    setTimeout(function(){
    document.getElementById("WATER-RESISTANT").click();
      }, 20);
  };

  
 // if(group == "OP"){document.getElementById("OP-wrapper").click()} else if(group == "ST"){document.getElementById("ST-wrapper").click()} else if(group == "OP"){document.getElementById("WR-wrapper").click()};

var blank = 0;   

var fifegranite = document.querySelector("div[data-option-value='Fife Granite']");
var fifeplatinum = document.querySelector("div[data-option-value='Fife Platinum']");
var fifenickel = document.querySelector("div[data-option-value='Fife Nickel']");
var fifevesterhavsand = document.querySelector("div[data-option-value='Fife Vesterhav Sand']");
var fiferainygrey = document.querySelector("div[data-option-value='Fife Rainy Grey']");
var fifecanvasgrey = document.querySelector("div[data-option-value='Fife Canvas Grey']");
var fifebone = document.querySelector("div[data-option-value='Fife Bone']");
var fifesootblue = document.querySelector("div[data-option-value='Fife Soot Blue']");
var fifenightshade = document.querySelector("div[data-option-value='Fife Nightshade']");
var fifeolive = document.querySelector("div[data-option-value='Fife Olive']");
var fifelichen = document.querySelector("div[data-option-value='Fife Lichen']");
var fifesilkygreen = document.querySelector("div[data-option-value='Fife Silky Green']");
var fifequinceyellow = document.querySelector("div[data-option-value='Fife Quince Yellow']");
var fifesalmon = document.querySelector("div[data-option-value='Fife Salmon']");
var fifewarmrose = document.querySelector("div[data-option-value='Fife Warm Rose']");
var robbengrey = document.querySelector("div[data-option-value='Robben Grey']");
var robbencharcoal = document.querySelector("div[data-option-value='Robben Charcoal']");
var heritageashe = document.querySelector("div[data-option-value='Heritage Ashe']");
var heritagesable = document.querySelector("div[data-option-value='Heritage Sable']");
var pinstripecoal = document.querySelector("div[data-option-value='Pinstripe Coal']");
var pinstripefog = document.querySelector("div[data-option-value='Pinstripe Fog']");
var poolsidecoal = document.querySelector("div[data-option-value='Poolside Coal']");
var poolsidesmoke = document.querySelector("div[data-option-value='Poolside Smoke']");
var poolsidelinen = document.querySelector("div[data-option-value='Poolside Linen']");
var loom3castlerock = document.querySelector("div[data-option-value='Loom 3 Castlerock']");
var huntdune = document.querySelector("div[data-option-value='Hunt Dune']");
var huntgreystone = document.querySelector("div[data-option-value='Hunt Greystone']");
var huntraven = document.querySelector("div[data-option-value='Hunt Raven']");
var loomcastlerock = document.querySelector("div[data-option-value='Loom Castle Rock']");
var dotoyster = document.querySelector("div[data-option-value='Dot Oyster']");
var dotnimbus = document.querySelector("div[data-option-value='Dot Nimbus']");
var dotputty = document.querySelector("div[data-option-value='Dot Putty']");
var wavebuff = document.querySelector("div[data-option-value='Wave Buff']");
var wavegravel = document.querySelector("div[data-option-value='Wave Gravel']");
var wavequarry = document.querySelector("div[data-option-value='Wave Quarry']");
var waverusset = document.querySelector("div[data-option-value='Wave Russet']");
var tuckmalt = document.querySelector("div[data-option-value='Tuck Malt']");
var tucktruffle = document.querySelector("div[data-option-value='Tuck Truffle']");
var tuckdust = document.querySelector("div[data-option-value='Tuck Dust']");
var tucksable = document.querySelector("div[data-option-value='Tuck Sable']");
var tuckdenim = document.querySelector("div[data-option-value='Tuck Denim']");
var tuckcider = document.querySelector("div[data-option-value='Tuck Cider']");
var raveldune = document.querySelector("div[data-option-value='Ravel Dune']");
var ravelsable = document.querySelector("div[data-option-value='Ravel Sable']");
var ravelginger = document.querySelector("div[data-option-value='Ravel Ginger']");
var sailingseagull = document.querySelector("div[data-option-value='Sailing Seagull']");
var camerongranite = document.querySelector("div[data-option-value='Cameron Granite']");
var cameronanthracite = document.querySelector("div[data-option-value='Cameron Anthracite']");
var blendsand = document.querySelector("div[data-option-value='Blend Sand']");
var blendlinen = document.querySelector("div[data-option-value='Blend Linen']");
var blendfog = document.querySelector("div[data-option-value='Blend Fog']");
var blendcoal = document.querySelector("div[data-option-value='Blend Coal']");
var blendclay = document.querySelector("div[data-option-value='Blend Clay']");
var fifeice = document.querySelector("div[data-option-value='Fife Ice']");
var fifegrey = document.querySelector("div[data-option-value='Fife Grey']");
var fifeebony = document.querySelector("div[data-option-value='Fife Ebony']");
var fifeshadow = document.querySelector("div[data-option-value='Fife Shadow']");
var blendlatte = document.querySelector("div[data-option-value='Blend Latte']");
  
var OPcount = 0;
var STcount = 0;
var WRcount = 0;
  
  
var group = "";   
  
const outdoorperformanceArray = [
    fifegranite,
    fifeplatinum,
    fifenickel,
    fifevesterhavsand,
    fiferainygrey,
    fifecanvasgrey,
    fifebone,
    fifesootblue,
    fifenightshade,
    fifeolive,
    fifelichen,
    fifesilkygreen,
    fifequinceyellow,
    fifesalmon,
    fifewarmrose,
    robbengrey,
    robbencharcoal,
    heritageashe,
    heritagesable,
    pinstripecoal,
    pinstripefog,
    poolsidecoal,
    poolsidesmoke,
    poolsidelinen,
   	huntdune,
    huntgreystone,
    huntraven,
    loomcastlerock,
    loom3castlerock    
];  

const softtouchArray = [
    dotoyster,
    dotnimbus,
    dotputty,
    wavebuff,
    wavegravel,
    wavequarry,
    waverusset,
    tuckmalt,
    tucktruffle,
    tuckdust,
    tucksable,
    tuckdenim,
    tuckcider,
    raveldune,
    ravelsable,
    ravelginger
];  
  
const waterresistantArray = [
    sailingseagull,
    camerongranite,
    cameronanthracite,
    blendsand,
    blendlinen,
    blendfog,
    blendcoal,
    blendclay,
    fifeice,
    fifegrey,
    fifeebony,
    fifeshadow,
    blendlatte
];   
  
for (var i = 0; i < outdoorperformanceArray.length; i++) {
	if(outdoorperformanceArray[i] != null) {
    	OPcount ++;
    }  
}
  
for (var i = 0; i < softtouchArray.length; i++) {
	if(softtouchArray[i] != null) {
    	STcount ++;
    }  
}
  
for (var i = 0; i < waterresistantArray.length; i++) {
	if(waterresistantArray[i] != null) {
    	WRcount ++;
    }  
}
  
  var sgroup = localStorage.getItem('lcgroup');
  if(sgroup == "OP"){
    document.getElementById("OUTDOOR-PERFORMANCE").checked = true;;
  } else if(sgroup == "ST"){
    document.getElementById("SOFT-TOUCH").checked = true;
  } else if(sgroup == "WR"){
	document.getElementById("WATER-RESISTANT").checked = true;
  };

if(OPcount >= 1 && sgroup == ""){
        document.getElementById("OUTDOOR-PERFORMANCE").checked = true;
}else if(STcount >= 1 && sgroup == ""){
        document.getElementById("SOFT-TOUCH").checked = true;
}else if(WRcount >= 1 && sgroup == ""){
        document.getElementById("WATER-RESISTANT").checked = true;
}


  

  
groupselector();

document.getElementById("OP-wrapper").onclick = function() {groupselector()};
document.getElementById("ST-wrapper").onclick = function() {groupselector()};
document.getElementById("WR-wrapper").onclick = function() {groupselector()};  
  
function groupselector(){ 
  

var OP = document.getElementById("OUTDOOR-PERFORMANCE").checked;
var ST = document.getElementById("SOFT-TOUCH").checked;
var WR = document.getElementById("WATER-RESISTANT").checked;    
 

if(OPcount != 0 || STcount != 0 || WRcount != 0){ 
    if(OP==true){
		group = "OP";
        document.getElementById("OP-wrapper").children[2].style.opacity="1";
        document.getElementById("OP-wrapper").children[4].style.opacity="1";
        for (var i = 0; i < outdoorperformanceArray.length; i++) {
        	var opa = outdoorperformanceArray[i];
          	if(opa != null) {opa.style.display="block";}
    	}
        for (var i = 0; i < softtouchArray.length; i++) {
        	var sta = softtouchArray[i];
          	if(sta != null) {sta.style.display="none";}
    	}
        for (var i = 0; i < waterresistantArray.length; i++) {
        	var wta = waterresistantArray[i];
          	if(wta != null) {wta.style.display="none";}
    	}
      
    }else{
        document.getElementById("OP-wrapper").children[2].style.opacity="0.5";
        document.getElementById("OP-wrapper").children[4].style.opacity="0.5";      
		if(OPcount == 0){document.getElementById("OP-wrapper").style.display="none"; }
  
    }
    if(ST==true){
		group = "ST";
        document.getElementById("ST-wrapper").children[2].style.opacity="1";
        document.getElementById("ST-wrapper").children[4].style.opacity="1";
        for (var i = 0; i < softtouchArray.length; i++) {
        	var sta = softtouchArray[i];
          	if(sta != null) {sta.style.display="block";}
    	}
        for (var i = 0; i < outdoorperformanceArray.length; i++) {
        	var opa = outdoorperformanceArray[i];
        	if(opa != null) {opa.style.display="none";}
    	}
        for (var i = 0; i < waterresistantArray.length; i++) {
        	var wta = waterresistantArray[i];
          	if(wta != null) {wta.style.display="none";}
    	}
    }else{
        document.getElementById("ST-wrapper").children[2].style.opacity="0.5";
        document.getElementById("ST-wrapper").children[4].style.opacity="0.5";
        if(STcount == 0){document.getElementById("ST-wrapper").style.display="none"; }
    
    }
    if(WR==true){
		group = "WR";	
        document.getElementById("WR-wrapper").children[2].style.opacity="1";
        document.getElementById("WR-wrapper").children[4].style.opacity="1";
        for (var i = 0; i < waterresistantArray.length; i++) {
        	var wta = waterresistantArray[i];
          	if(wta != null) {wta.style.display="block";}
    	}
        for (var i = 0; i < outdoorperformanceArray.length; i++) {
        	var opa = outdoorperformanceArray[i];
          	if(opa != null) {opa.style.display="none";}
    	}
        for (var i = 0; i < softtouchArray.length; i++) {
        	var sta = softtouchArray[i];
          	if(sta != null) {sta.style.display="none";}
    	}
    }else{
        document.getElementById("WR-wrapper").children[2].style.opacity="0.5";
        document.getElementById("WR-wrapper").children[4].style.opacity="0.5";
        if(WRcount == 0){document.getElementById("WR-wrapper").style.display="none"; }
    }
    if(outdoorperformanceArray == null){
        document.getElementById("OP-wrapper").style.display="none";
    }
    if(softtouchArray == null){
    document.getElementById("ST-wrapper").style.display="none";
    }
    if(waterresistantArray == null){
    document.getElementById("WR-wrapper").style.display="none";
    }
  
  	
  
}else{
    document.getElementById("RADIO-TOOLBAR").style.display="none";
    /*fifegranite.style.display="none";
    dotnimbus.style.display="none";
    blendclay.style.display="none";*/
}
	document.getElementsByClassName('radio-toolbar')[0].style.setProperty("display", "flex", "important");
	localStorage.setItem('lcgroup', group);
} 
 